import "../../../assets/scss/rent-summary-modal-style.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, message } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  updateGPUCountSelectionInfo,
  removeSelectionInfo,
} from "../../features/selection/selectionSlice";
import { returnkW } from "../../utility/fn";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../utility/AuthContext";

export const RentSummaryModal = ({
  closeModal,
}: {
  closeModal: () => void;
}) => {
  const { t } = useTranslation();
  const userState = useAppSelector((state: any) => state.user);
  const selectionState = useAppSelector((state: any) => state.selection);
  const { isLoggedIn, setShowLoginModal } = useAuth();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [amount, setAmount] = useState<number>(1);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();

  const API_ROUTE = process.env.REACT_APP_API_BASE_URL;

  const selectedAll = selectionState.gpu.selected_as_whole;
  let token = userState.token.access_token;

  useEffect(() => {
    if (!isLoggedIn) {
      setShowLoginModal(true);
    }

    if (selectionState.gpu.product_name === undefined) {
      navigate("/");
    }

    if (selectionState.gpu) {
      setTotalPrice(Number(selectionState.gpu.price));
    }
  }, [selectionState]);

  useEffect(() => {
    let newPrice = Number(selectionState.gpu.price) * amount;
    setTotalPrice(Number(newPrice.toFixed(2)));
  }, [amount]);

  const increaseAmount = () => {
    if (amount < selectionState.gpu.gpu_available) {
      const newVal = amount + 1;
      setAmount(newVal);
      dispatch(updateGPUCountSelectionInfo(newVal));
    }
  };

  const decreaseAmount = () => {
    if (amount > 1) {
      const newVal = amount - 1;
      setAmount(newVal);
      dispatch(updateGPUCountSelectionInfo(newVal));
    }
  };

  const startGPURental = () => {
    setLoading(true);
    fetch(`${API_ROUTE}instances`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "text/event-stream",
      },
      body: JSON.stringify({
        gpu_count: selectionState.selected_gpu_count,
        host_id: selectionState.gpu.host_id,
        service_name: "test1234",
        runtime: "nvidia",
        template_id: selectionState.template_id,
      }),
    });
    setTimeout(() => {
      navigate("/instances");
      dispatch(removeSelectionInfo());
    }, 1000);
  };
  if (!selectionState.gpu) return null;

  return (
    <div className="rent-summary-modal">
      {contextHolder}

      <h3 className="modal-title">{selectionState.gpu.product_name}</h3>

      {/* Specs two-column */}
      <div className="specs-grid">
        <div>
          <span className="label">{t("GPU RAM")}</span>
          <span>{selectionState.gpu.gpu_ram} GB</span>
        </div>
        <div>
          <span className="label">{t("Disk Storage")}</span>
          <span>{selectionState.gpu.disk_max_available_storage} GB</span>
        </div>
        <div>
          <span className="label">{t("CPU")}</span>
          <span>{selectionState.gpu.cpu_name}</span>
        </div>
        <div>
          <span className="label">{t("Effective RAM")}</span>
          <span>{selectionState.gpu.effective_ram} GB</span>
        </div>
      </div>

      {/* GPU Amount */}
      <div className="gpu-amount">
        <span className="label">{t("GPU Amount")}</span>
        <div className="gpu-amount-container">
          <div className="amount-control">
            <button onClick={decreaseAmount} disabled={amount <= 1}>
              -
            </button>
            <span className="amount">{amount}</span>
            <button
              onClick={increaseAmount}
              disabled={amount >= selectionState.gpu.gpu_available}
            >
              +
            </button>
          </div>
          <span className="available">
            {selectionState.gpu.gpu_available} {t("Available GPUs")}
          </span>
        </div>
      </div>

      {/* Price Section */}
      <div className="price-section">
        <span className="label">{t("Price")}</span>
        <div className="sub-price">
          {amount} GPU × ${selectionState.gpu.price} / hour
        </div>
        <h2>
          {t("Total Cost")} : <b>${totalPrice} / hour</b>
        </h2>
      </div>

      {/* Extra Specs */}
      <div className="extra-specs">
        <div>
          <span className="label">{t("Internet Speed")}:</span>
          <span>
            <ArrowUpOutlined /> {selectionState.gpu.internet_upload_speed}{" "}
            Mbps&nbsp;/&nbsp;
            <ArrowDownOutlined /> {
              selectionState.gpu.internet_download_speed
            }{" "}
            Mbps
          </span>
        </div>
        <div>
          <span className="label">{t("Watt")}:</span>
          <span>{returnkW(selectionState.gpu.product_name)} kWatt</span>
        </div>
      </div>

      {/* Rent Button */}
      <Button
        type="primary"
        onClick={startGPURental}
        loading={loading}
        className="rent-button"
      >
        {t("Rent")}
      </Button>
    </div>
  );
};
